export default __webpack_public_path__ + "static/media/marketplace-application.2837a637.png";